module.exports = __webpack_public_path__ + "img/espa-alt.4237546d.jpg";